export const LOGIN_LITERALS = {
  support:
    "For support, please reach out to our support team at eagleadmin@precedencehealthcare.com",
  copyRights: "Copyright © 2025 Precedence Health Care Pty Ltd",
  somethingWentWrong: "Something went wrong",
  accessDenied: "Access Denied",
  passwordAlreadySet:
    "Your password set up is complete. Please sign in to continue.",
  signIn: "Sign In",
  passwordSuccessfullySet: "Password has been set successfully",
  welcome: "Welcome",
  enterCode: "Enter Code",
  resendOtp: "Resend Code",
  validate: "Validate",
  otpInfo:
    "A one time password (a 6-digit number) has been sent to your registered email address. Please enter it below and click Validate. This code is valid for 15 minutes.",
  sessionExpired: "Session expired.",
  passwordUpdatedSuccessfully:
    "Password updated successfully. Please login with new credentials.",
  passwordUpdated: "Password updated successfully.",
  ageValidation: "Please enter the valid details.",
  emailExists: "An error occurred while registering the new clinic.",
};

export const ErrorMessage = {
  ErrorAccountLocked:
    "Account locked due to invalid login attempts. Please try again after",
  ErrorInvalidUser: "Invalid username or password. Number of attempts left: ",
};
